import React, { useContext } from 'react'
import ImageWithBasePath from '../components/ImageWithBasePath'
import { trackEvent } from '../analytics'
import { advertiserAnalyticOptions } from '../utils/functions'
import { Media } from './Media'
import { AdvertiserPrimaryButton } from './AdvertiserPrimaryButton'
import { useRouterHook } from '../hooks/useRouterHook'
import { SharedContext } from '@/context/SharedContext'
import { AdvertiserContext } from '@/context/AdvertiserContext'
import { isLegacyNewsWebView } from '@/android/bridge'

export const PostJobHeader = ({
  postJobPresentStep,
  headerCallback = () => {},
  isDashboardButton = false
}) => {
  const { replaceThePageInAdvertiser } = useRouterHook()
  const { utmParams } = useContext(SharedContext)

  const {
    setpostJobPresentStep,
    // setPaymentBackModalOpen,
    enterpriseLoginDetails
  } = useContext(AdvertiserContext)

  const backHandler = ({}) => {
    if (isLegacyNewsWebView()) {
      if (postJobPresentStep === 1) Android.closeWebForm()
      else if (postJobPresentStep === 4) Android.onFinishFlow()
      else {
        setpostJobPresentStep((prv) => (prv != 1 ? prv - 1 : prv))
      }
      return
    }
    headerCallback()
    if (postJobPresentStep === 1) {
      replaceThePageInAdvertiser({
        pathName: 'advertiserDashboardPage',
        as: 'dashboard'
      })
      trackEvent({
        name: 'tap_back_job_details_screen',
        searchParams: utmParams,
        options: advertiserAnalyticOptions({
          label: 'job_creation_job_details',
          Page_no: 'page_1',
          Event_type: 'tap',
          enterprise: !!enterpriseLoginDetails?.advertiserId
        })
      })
    } else {
      trackEvent({
        name:
          postJobPresentStep === 2
            ? 'tap_back_candidate_requirements_screen'
            : postJobPresentStep === 3
            ? 'tap_back_company_details_screen'
            : 'tap_back_choose_plan_screen',
        searchParams: utmParams,
        options: advertiserAnalyticOptions({
          Page_no: 'page_1',
          Event_type: 'tap',
          enterprise: !!enterpriseLoginDetails?.advertiserId
        })
      })
      setpostJobPresentStep((prv) => (prv != 1 ? prv - 1 : prv))
    }
  }
  return (
    <div>
      <div
        id="postJobHeader"
        className="shadow-[0px 4px 4px rgba(196, 196, 196, 0.13)] sticky top-0 z-20 flex h-[56px] items-center bg-white px-[23px]"
      >
        <div className="flex">
          <div className="cursor-pointer" onClick={backHandler}>
            <ImageWithBasePath
              src={'post_job_back'}
              width={24}
              height={24}
              alt="back button arrow"
            />
          </div>
          <div className="ml-[21px] font-noto-sans text-lg font-bold leading-[24.52px] text-[#333436]">
            Post a job
          </div>
        </div>
        <div className="flex flex-1 justify-end">
          {isDashboardButton && (
            <Media greaterThanOrEqual="sm">
              <div className="h-[40px] w-[140px] cursor-pointer ">
                <AdvertiserPrimaryButton
                  title={'Go to dashboard'}
                  isCPMFlowMedium={true}
                  isCsat={true}
                  isArrowPresent={false}
                  extraClassName="bg-white border-[1px] border-solid border-[#4B4B4B] hover:border-[1px]"
                  onClick={() => {
                    replaceThePageInAdvertiser({
                      pathName: 'advertiserDashboardPage',
                      as: 'dashboard'
                    })
                  }}
                />
              </div>
            </Media>
          )}
        </div>
      </div>
    </div>
  )
}
